/**
 * User-manager-auth REST base (`/auth/login`, `/auth/refresh-token`, etc.).
 * Host comes from `__TRACE_ADDIN_AUTH_API_ORIGIN__` (webpack); aligns with `authApiOrigin` in deploy profile.
 */
const USERMANAGER_AUTH_API_BASE = `${__TRACE_ADDIN_AUTH_API_ORIGIN__}/usermanagerauth/api/v1/auth`;

/** Login URL is inlined into `src/auth/callback.html` via HtmlWebpackPlugin (dialog has no bundle). */
export const TRACE_ADDIN_AUTH_LOGIN_URL = `${USERMANAGER_AUTH_API_BASE}/login`;

export const TRACE_ADDIN_DEFAULT_REFRESH_TOKEN_URL = `${USERMANAGER_AUTH_API_BASE}/refresh-token`;
